var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 bg-danger text-light"},[_c('p',{staticClass:"font-weight-light  m-0 p-0"},[_c('icon',{attrs:{"name":"mdi.alert-outline"}}),_c('translate',{attrs:{"text":_vm.translateKey}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }